import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ag-add-patron-error',
  templateUrl: './add-patron-error.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddPatronErrorDialog implements OnInit {
  name: string;
  messages: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<AddPatronErrorDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.name = this.data.name;
    this.messages = this.data.messages;
  }
}
